// Layer 3 (Transformation): TARP ladder chain strings for the rule-set row.
// Pure derivation — no React, no engine mutation.

import type { EscalationLadder, EscalationTier } from '@/versions/v1/schema/escalation-ladder';
import { roleShortLabel } from '@/versions/v1/shared/org';

function ladderRoleAbbrev(role: EscalationTier['role']): string {
  if (role === 'operator') return 'Op';
  return roleShortLabel(role) ?? role;
}

function formatTierDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h > 0 && m === 0) return `${h} h`;
  if (h === 0) return `${m} m`;
  return `${h} h ${m} m`;
}

export function formatLadderChain(ladder: EscalationLadder): string {
  return ladder.tiers
    .map((tier) => `${ladderRoleAbbrev(tier.role)} ${formatTierDuration(tier.timeLimitMinutes)}`)
    .join(' → ');
}

export function ladderTooltip(ladder: EscalationLadder): string {
  const feedTier = ladder.tiers.find((tier) => tier.feedRateChangePct !== undefined);
  const feedNote = feedTier
    ? ` · feed ${feedTier.feedRateChangePct! > 0 ? '+' : ''}${feedTier.feedRateChangePct}%`
    : '';
  return `${ladder.id} · source: tarp${feedNote}`;
}
